import type { AnalyticsBrowser } from '@segment/analytics-next';
import { captureException } from '@sentry/react';
import mixpanel from 'mixpanel-browser';

export function initializeMixpanel(analytics?: AnalyticsBrowser) {
  try {
    mixpanel.init(import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN, {
      debug: true,
      record_block_selector: 'video, canvas',
      record_mask_text_selector:
        'input[type="text"], input[type="password"], input[type="email"], textarea',
      record_sessions_percent: 10,
      ignore_dnt: true,
    });

    analytics?.addSourceMiddleware(({ payload, next }) => {
      if (payload.obj.type === 'track' || payload.obj.type === 'page') {
        const segmentDeviceId = payload.obj.anonymousId;
        // Simplified ID Merge
        mixpanel.register({
          $device_id: segmentDeviceId,
          distinct_id: '$device:' + segmentDeviceId,
        });

        const sessionReplayProperties =
          mixpanel.get_session_recording_properties();

        payload.obj.properties = {
          ...payload.obj.properties,
          ...sessionReplayProperties,
        };
      }
      if (payload.obj.type === 'identify') {
        const userId = payload.obj.userId;
        mixpanel.identify(userId ?? undefined);
      }
      next(payload);
    });
  } catch (e) {
    console.error(e);
    captureException(e);
  }
}

export function startRecording() {
  mixpanel.start_session_recording();
}

export function stopRecording() {
  mixpanel.stop_session_recording();
}
